import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cached = null;

export function useConfig() {
  const [config, setConfig] = useState(cached || { booking_url: null });

  useEffect(() => {
    if (cached) return;
    axios.get(`${API}/config`).then((res) => {
      cached = res.data;
      setConfig(res.data);
    }).catch(() => {});
  }, []);

  return config;
}
